import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE = "https://nea-mitica.ro";

const restaurantSchema = (r) => ({
  "@context": "https://schema.org",
  "@type": "Restaurant",
  name: r.name,
  servesCuisine: r.cuisine,
  telephone: r.phone,
  priceRange: "$$",
  address: {
    "@type": "PostalAddress",
    streetAddress: r.street,
    addressLocality: "București",
    postalCode: r.zip,
    addressCountry: "RO",
  },
  openingHours: "Mo-Su 11:00-23:00",
  acceptsReservations: "True",
  url: `${BASE}${r.path}`,
  image: `${BASE}${r.image}`,
});

const META = {
  home: {
    title: "Nea Mitică | Restaurant Românesc la Zoo (Băneasa) · Pizza & Paste la Unirii",
    description: "Două case în București: restaurant cu specific românesc vis-a-vis de Grădina Zoologică (Băneasa) și pizza & paste la cuptor cu lemne în zona Unirii. Program zilnic 11:00–23:00.",
    image: "/assets/hero-toast.jpg",
  },
  zoo: {
    title: "Nea Mitică — Zoo Băneasa | Restaurant Românesc vis-a-vis de Grădina Zoologică",
    description: "Mici faimoși, ciorbe ca la mama, grătare de la jar și papanași, pe terasa umbrită de pe Str. Vadul Moldovei 15, Băneasa. Zilnic 11:00–23:00. Rezervări și comenzi acasă (Pipera–Iancu Nicolae–Șisești): 0749 230 991.",
    image: "/assets/zoo/terasa-noua.jpg",
    schema: restaurantSchema({
      name: "Nea Mitică — Zoo Băneasa",
      cuisine: ["Românesc", "Grătar"],
      phone: "+40749230991",
      street: "Str. Vadul Moldovei 15",
      zip: "077190",
      path: "/zoo",
      image: "/assets/zoo/terasa-noua.jpg",
    }),
  },
  unirii: {
    title: "Nea Mitică Pizza Pasta & More — Restaurant Unirii, București",
    description: "Pizza la cuptor cu lemne, paste proaspete și tiramisu artizanal pe Bd. Corneliu Coposu 6-8, zona Unirii. Zilnic 11:00–23:00. Rezervări telefonice: 0743 227 124.",
    image: "/assets/unirii/cuptor-foc.jpg",
    schema: restaurantSchema({
      name: "Nea Mitică — Pizza Pasta & More",
      cuisine: ["Pizza", "Paste", "Italiană"],
      phone: "+40743227124",
      street: "Bd. Corneliu Coposu 6-8",
      zip: "030606",
      path: "/unirii",
      image: "/assets/unirii/cuptor-foc.jpg",
    }),
  },
};

const setTag = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const SEO = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const key = pathname === "/" ? "home" : pathname.replace("/", "");
    const m = META[key] || META.home;
    const origin = window.location.origin;
    const url = origin + pathname;

    document.title = m.title;
    setTag("name", "description", m.description);
    setTag("property", "og:title", m.title);
    setTag("property", "og:description", m.description);
    setTag("property", "og:type", "website");
    setTag("property", "og:url", url);
    setTag("property", "og:image", origin + m.image);
    setTag("property", "og:site_name", "Nea Mitică");
    setTag("property", "og:locale", "ro_RO");
    setTag("name", "twitter:card", "summary_large_image");

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = url;

    document.querySelectorAll("script[data-seo-jsonld]").forEach((s) => s.remove());
    if (m.schema) {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo-jsonld", "1");
      s.textContent = JSON.stringify(m.schema);
      document.head.appendChild(s);
    }
  }, [pathname]);

  return null;
};
